import React from "react";
import { Menu, X, Target, ZoomIn, ZoomOut } from "lucide-react";
import ProfileDropdown from "./ProfileDropdown";

function MapControls({
  sidebarOpen,
  onToggleSidebar,
  isDrawing,
  search,
  onSearchChange,
  onCancelDrawing,
  onZoomIn,
  onZoomOut,
}) {
  return (
    <>
      <button
        className="classified-menu-toggle md:hidden"
        onClick={onToggleSidebar}
        aria-label={sidebarOpen ? "Close location archive" : "Open location archive"}
      >
        {sidebarOpen ? <X size={22} /> : <Menu size={22} />}
      </button>

      <div className="classified-map-controls">
        {isDrawing && (
          <div className="classified-drawing-notice">
            <div className="flex items-center gap-2">
              <Target size={16} />
              <span>Tap a point on the map</span>
            </div>
          </div>
        )}

        <div className="classified-map-search">
          <span className="map-search-code">Search the map</span>
          <label>
            <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
            <input
              type="search"
              placeholder="Search locations"
              value={search}
              onChange={onSearchChange}
              aria-label="Search locations"
            />
          </label>
        </div>
        <ProfileDropdown />
      </div>

      {isDrawing && (
        <button
          onClick={onCancelDrawing}
          className="classified-cancel-drawing"
        >
          <X size={16} />
          Cancel selection
        </button>
      )}

      <div className="mobile-map-zoom md:hidden" aria-label="Map zoom controls">
        <button type="button" onClick={onZoomIn} aria-label="Zoom in">
          <ZoomIn size={20} />
        </button>
        <button type="button" onClick={onZoomOut} aria-label="Zoom out">
          <ZoomOut size={20} />
        </button>
      </div>
    </>
  );
}

export default MapControls;
